import CoursesMenuDesktop from "./courses-menu/courses-menu-desktop";
import CoursesMenuMobile from "./courses-menu/courses-menu-mobile";

export class CourseMenuLoader {
    constructor(sprintMode = false) {
        if (sprintMode) {
            this.$siteHeader = document.getElementById('siteHeader');
        } else {
            this.$siteHeader = document.querySelector('.site-header');
        }
        this.$desktopCourseMenu = document.getElementById('coursesMenuDesktop');
        this.$mobileCourseMenuSection = document.getElementById('mobileCourseMenuSection');

        this.sprintMode = sprintMode;
    }

    loadDesktopCourseMenu(dropdownService) {
        this.initDesktopCourseMenu(dropdownService);
    }

    loadMobileCourseMenu(mobileNavModule) {
        this.initMobileCourseMenu(mobileNavModule);
    }

    initDesktopCourseMenu(dropdownService) {
        const $trigger = this.$siteHeader.querySelector('[data-dropdown-trigger="coursesMenu"]');
        const coursesMenu = new CoursesMenuDesktop(this.$desktopCourseMenu);

        this.$desktopCourseMenu.classList.remove('-not-loaded');

        if ($trigger.classList.contains('-active') && !coursesMenu.initialized) {
            coursesMenu.init();
        }

        const courseMenuDropdown = dropdownService.dropdowns.find((dropdown) => dropdown.id === 'coursesMenu');

        if (courseMenuDropdown) {
            courseMenuDropdown.subscribe('beforeShow', () => {
                if (!coursesMenu.initialized) {
                    coursesMenu.init();
                }
            });
        }
    }

    initMobileCourseMenu(mobileNavModule) {
        const $mobileNavMenuSections = document.getElementById('mobileNavMenuSections');
        const courseMenu = new CoursesMenuMobile(document.getElementById('coursesNavMobile'));

        if ($mobileNavMenuSections && $mobileNavMenuSections.dataset.active === 'courses-menu' && !courseMenu.initialized) {
            courseMenu.init();
        }

        document.getElementById('coursesMenuMobileTrigger')
            .addEventListener('click', () => {
                if (!courseMenu.initialized) {
                    courseMenu.init();
                }

                mobileNavModule.$sectionsContainer = document.getElementById('mobileNavMenuSections');
                mobileNavModule.$sectionList = mobileNavModule.$root.querySelectorAll('.mobile-nav-menu_section');
                mobileNavModule.$sectionsContainer.dataset.active = 'courses-menu';
                mobileNavModule.$header.classList.add('-back');
                mobileNavModule.setHeight();
                scrollLock.enablePageScroll();
                scrollLock.disablePageScroll(mobileNavModule.$sectionList);
            });
    }
}